import { StaffEntity } from '@/entities/staff.entity';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import Attendance0 from '@/assets/image/attendance_0.png';
import Attendance1 from '@/assets/image/attendance_1.png';
import Attendance2 from '@/assets/image/attendance_2.png';
import Attendance3 from '@/assets/image/attendance_3.png';
import Attendance4 from '@/assets/image/attendance_4.png';
import Attendance5 from '@/assets/image/attendance_5.png';
import Contribute0 from '@/assets/image/contribute_0.png';
import Contribute1 from '@/assets/image/contribute_1.png';
import Contribute2 from '@/assets/image/contribute_2.png';
import Contribute3 from '@/assets/image/contribute_3.png';
import Contribute4 from '@/assets/image/contribute_4.png';
import Contribute5 from '@/assets/image/contribute_5.png';
import Grow0 from '@/assets/image/grow_0.png';
import Grow1 from '@/assets/image/grow_1.png';
import Grow2 from '@/assets/image/grow_2.png';
import Grow3 from '@/assets/image/grow_3.png';
import Grow4 from '@/assets/image/grow_4.png';
import Grow5 from '@/assets/image/grow_5.png';
import Purpose0 from '@/assets/image/purpose_0.png';
import Purpose1 from '@/assets/image/purpose_1.png';
import Purpose2 from '@/assets/image/purpose_2.png';
import Purpose3 from '@/assets/image/purpose_3.png';
import Purpose4 from '@/assets/image/purpose_4.png';
import Purpose5 from '@/assets/image/purpose_5.png';
import Relationships0 from '@/assets/image/relationships_0.png';
import Relationships1 from '@/assets/image/relationships_1.png';
import Relationships2 from '@/assets/image/relationships_2.png';
import Relationships3 from '@/assets/image/relationships_3.png';
import Relationships4 from '@/assets/image/relationships_4.png';
import Relationships5 from '@/assets/image/relationships_5.png';

@Component<SingleUserBaseMixin>({
  computed: {
    ...mapGetters('staff', ['getStaffById', 'currentStaff']),
  },
  methods: {
    ...mapActions('staff', ['fetchStaffById']),
  },
})
export default class SingleUserBaseMixin extends Vue {
  @Prop({ type: Object as PropType<StaffEntity>, required: false })
  user: StaffEntity;

  @Prop({ type: Number, required: false })
  staffId: number;

  getStaffById!: (id) => StaffEntity;
  fetchStaffById!: (staffId: number) => void;

  get getUser() {
    if (this.staffId) {
      return this.getStaffById(this.staffId);
    }
    return this.user;
  }

  get getGrow() {
    if (!this.getUser.staffTitleExecuteCount || this.getUser.staffTitleExecuteCount?.grow === 0)
      return { image: Grow0, level: 1 };
    const [start, level] = this.calcStaffTitle(this.getUser.staffTitleExecuteCount.grow);
    switch (start) {
      case 0:
        return { image: Grow0, level };
      case 1:
        return { image: Grow1, level };
      case 2:
        return { image: Grow2, level };
      case 3:
        return { image: Grow3, level };
      case 4:
        return { image: Grow4, level };
      case 5:
        return { image: Grow5, level };
      default:
        return { image: Grow5, level };
    }
  }

  get getRelationships() {
    if (
      !this.getUser.staffTitleExecuteCount ||
      this.getUser.staffTitleExecuteCount?.relationships === 0
    )
      return { image: Relationships0, level: 1 };
    const [start, level] = this.calcStaffTitle(this.getUser.staffTitleExecuteCount.relationships);
    switch (start) {
      case 0:
        return { image: Relationships0, level };
      case 1:
        return { image: Relationships1, level };
      case 2:
        return { image: Relationships2, level };
      case 3:
        return { image: Relationships3, level };
      case 4:
        return { image: Relationships4, level };
      case 5:
        return { image: Relationships5, level };
      default:
        return { image: Relationships5, level };
    }
  }

  get getAttendance() {
    if (
      !this.getUser.staffTitleExecuteCount ||
      this.getUser.staffTitleExecuteCount?.attendance === 0
    )
      return { image: Attendance0, level: 1 };
    const [start, level] = this.calcStaffTitle(this.getUser.staffTitleExecuteCount.attendance);
    switch (start) {
      case 0:
        return { image: Attendance0, level };
      case 1:
        return { image: Attendance1, level };
      case 2:
        return { image: Attendance2, level };
      case 3:
        return { image: Attendance3, level };
      case 4:
        return { image: Attendance4, level };
      case 5:
        return { image: Attendance5, level };
      default:
        return { image: Attendance5, level };
    }
  }

  get getContribute() {
    if (
      !this.getUser.staffTitleExecuteCount ||
      this.getUser.staffTitleExecuteCount?.contribute === 0
    )
      return { image: Contribute0, level: 1 };
    const [start, level] = this.calcStaffTitle(this.getUser.staffTitleExecuteCount.contribute);
    switch (start) {
      case 0:
        return { image: Contribute0, level };
      case 1:
        return { image: Contribute1, level };
      case 2:
        return { image: Contribute2, level };
      case 3:
        return { image: Contribute3, level };
      case 4:
        return { image: Contribute4, level };
      case 5:
        return { image: Contribute5, level };
      default:
        return { image: Contribute5, level };
    }
  }

  get getPurpose() {
    if (!this.getUser.staffTitleExecuteCount || this.getUser.staffTitleExecuteCount?.purpose === 0)
      return { image: Purpose0, level: 1 };
    const [start, level] = this.calcStaffTitle(this.getUser.staffTitleExecuteCount.purpose);
    switch (start) {
      case 0:
        return { image: Purpose0, level };
      case 1:
        return { image: Purpose1, level };
      case 2:
        return { image: Purpose2, level };
      case 3:
        return { image: Purpose3, level };
      case 4:
        return { image: Purpose4, level };
      case 5:
        return { image: Purpose5, level };
      default:
        return { image: Purpose5, level };
    }
  }

  calcStaffTitle(number: number) {
    const MAX_LEVEL = 593;
    const maxStart = 5;
    let start = Math.floor(number / 99);
    if (start > maxStart) {
      start = maxStart;
    }
    let level = number % 99;
    level += 1;
    if (number > MAX_LEVEL) {
      level = 99;
    }
    return [start, level];
  }
}
